import {createRouter, createWebHistory} from "vue-router"
import { appToastError } from '@/utils/appToast';
import {useAuthStore} from '@/stores/auth.js'

import NotFound from '@/pages/NotFound.vue'
import Guest from '@/layouts/Guest.vue'
// import Register from '@/pages/auth/Register.vue'
import Login from '@/pages/auth/Login.vue'
import TwoFactorChallenge from '@/pages/auth/TwoFactorChallenge.vue'
import ForgotPassword from '@/pages/auth/ForgotPassword.vue'
import ResetPassword from '@/pages/auth/ResetPassword.vue'
import VerifyEmail from '@/pages/auth/VerifyEmail.vue'
import UserSelect from '@/pages/auth/UserSelect.vue'

import Authenticated from '@/layouts/Authenticated.vue'
import ConfirmPassword from '@/pages/auth/ConfirmPassword.vue'
import Home from '@/pages/Home.vue'
import User from '@/pages/User.vue'
import Products from '@/pages/products/Index.vue'
import Countries from '@/pages/countries/Index.vue'
import Contracts from '@/pages/contracts/Index.vue'
import Organizations from '@/pages/organizations/Index.vue'
import VatRates from '@/pages/vatRates/Index.vue'
import SupplierOrders from '@/pages/supplierOrders/Index.vue'
import ProductEditPage from '@/pages/products/Edit.vue'
import ProductUnitsIndex from '@/pages/productUnits/Index.vue'
import ProductUnitEdit from '@/pages/productUnits/Edit.vue'
import OneCRequestsIndex from '@/pages/onecRequests/Index.vue'
import OtkReportsIndex from '@/pages/otkReports/Index.vue'
import DataCollectionIndex from '@/pages/dataCollection/Index.vue'
import DataCollectionShow from '@/pages/dataCollection/Show.vue'

// Подмодуль Storehouse
import { storehouseRoutes, workerMasterRoutes, receiptInvoiceRoutes, tsdScanRoutes } from '../../../modules/storehouse/resources/js/routes.js'
// Подмодуль Backup
import { backupRoutes } from '../../../modules/backup/resources/js/routes.js'
import CompanyIndex from '@/pages/company/Index.vue'
import UserIndex from '@/pages/user/Index.vue'
import ModulesIndex from '@/pages/modules/Index.vue'
import ModuleDetails from '@/pages/modules/ModuleDetails.vue'
import NavigationSettingsPage from '@/pages/navigation/NavigationSettingsPage.vue'
import ModuleGroupPage from '@/pages/navigation/ModuleGroupPage.vue'
import OrdersIndex from '@/pages/orders/Index.vue'
import AddOrEditOrderPage from '@/pages/orders/AddOrEditOrderPage.vue'
import ProductionIndex from '@/pages/production/Index.vue'
import ProductionOrderShow from '@/pages/production/OrderShow.vue'

import WorkshopIndex from '@/pages/worhshops/Index.vue'
import WorkshopPostIndex from '@/pages/workshopPosts/Index.vue'
import WorkshopPostUnitIndex from '@/pages/workshopPostUnits/Index.vue'
import WorkPlaceIndex from "@/pages/workPlace/WorkPlaceIndex.vue";
import WorkPlaceLayout from "@/layouts/WorkPlaceLayout.vue";
import SmkDeskIndex from "@/pages/smkDesk/SmkDeskIndex.vue";
import SmkDossierPage from "@/pages/smkDesk/SmkDossierPage.vue";
import ControlledUseForm from "@/pages/smkDesk/ControlledUseForm.vue";
import DeviationPermitForm from "@/pages/smkDesk/DeviationPermitForm.vue";
import RiskAssessmentForm from "@/pages/smkDesk/RiskAssessmentForm.vue";
import NcInvestigationForm from "@/pages/smkDesk/NcInvestigationForm.vue";
import ProductCorrectionForm from "@/pages/smkDesk/ProductCorrectionForm.vue";
import TechMap from "@/pages/production/TechMap.vue";
import TechMapEdit from "@/pages/production/TechMapEdit.vue";

import ResponsiveAuthenticated from "@/layouts/ResponsiveAuthenticated.vue"
import ViewBatchManufacture from '@/pages/batchManufactores/ViewBatchManufacture.vue'
import BatchProductsIndex from '@/pages/batchProducts/Index.vue'
import NotificationsIndex from '@/pages/notifications/Index.vue'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // Если есть сохраненная позиция (например, при использовании кнопки "Назад")
    if (savedPosition) {
      return savedPosition;
    }
    // Во всех остальных случаях переходим в начало страницы
    return { top: 0 };
  },
  routes: [
    // Подмодуль Storehouse роуты
    storehouseRoutes,
    workerMasterRoutes,
    backupRoutes,
    receiptInvoiceRoutes,
    tsdScanRoutes,
    {
      path: '/',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {path: "/", name: 'Home', component: Home},
        {path: "/user", name: 'User', component: User},
        {path: "/confirm-password", name: 'ConfirmPassword', component: ConfirmPassword},
      ]
    },
    {
      path: '/storekeeper-desk',
      component: WorkPlaceLayout,
      meta: {
        moduleParam: 'id', // все дочерние :id — id модуля стола
        requiresAuth: true,
        title: 'Рабочий центр'
      },
      children: [
        {
          path: ":id",
          name: 'StorekeeperWorkPlace', // Уникальное имя
          component: WorkPlaceIndex,
          props: true
        }
      ]
    },
    {
      path: '/picking-desk',
      component: WorkPlaceLayout,
      meta: {
        moduleParam: 'id', // все дочерние :id — id модуля стола
        requiresAuth: true,
        title: 'Рабочий центр'
      },
      children: [
        {
          path: ":id",
          name: 'PickingWorkPlace', // Уникальное имя
          component: WorkPlaceIndex,
          props: true
        }
      ]
    },
    {
      path: '/assembler-desk',
      component: WorkPlaceLayout,
      meta: {
        moduleParam: 'id', // все дочерние :id — id модуля стола
        requiresAuth: true,
        title: 'Рабочий центр'
      },
      children: [
        {
          path: ":id",
          name: 'AssemblerWorkPlace', // Уникальное имя
          component: WorkPlaceIndex,
          props: true
        }
      ]
    },
    {
      path: '/otk-desk',
      component: WorkPlaceLayout,
      meta: {
        moduleParam: 'id', // все дочерние :id — id модуля стола
        requiresAuth: true,
        title: 'Рабочий центр'
      },
      children: [
        {
          path: ":id",
          name: 'OtkWorkPlace', // Уникальное имя
          component: WorkPlaceIndex,
          props: true
        }
      ]
    },
    {
      path: '/packer-desk',
      component: WorkPlaceLayout,
      meta: {
        moduleParam: 'id', // все дочерние :id — id модуля стола
        requiresAuth: true,
        title: 'Рабочий центр'
      },
      children: [
        {
          path: ":id",
          name: 'PackerWorkPlace',
          component: WorkPlaceIndex,
          props: true
        }
      ]
    },
    {
      path: '/smk-desk',
      component: WorkPlaceLayout,
      meta: {
        moduleParam: 'id', // все дочерние :id — id модуля стола
        requiresAuth: true,
        title: 'Выпуск продукта'
      },
      children: [
        {
          path: ":id",
          name: 'SmkWorkPlace',
          component: SmkDeskIndex,
          props: true
        },
        {
          path: ":id/dossier/:taskId",
          name: 'SmkDossier',
          component: SmkDossierPage,
          props: true
        },
        {
          path: ":id/controlled-use/new",
          name: 'ControlledUseNew',
          component: ControlledUseForm,
          props: (route) => ({ moduleId: route.params.id, mode: 'create' })
        },
        {
          path: ":id/controlled-use/:controlledId",
          name: 'ControlledUseEdit',
          component: ControlledUseForm,
          props: (route) => ({
            moduleId: route.params.id,
            controlledId: route.params.controlledId,
            mode: 'edit'
          })
        },
        {
          path: ":id/deviation-permit/new",
          name: 'DeviationPermitNew',
          component: DeviationPermitForm,
          props: (route) => ({ moduleId: route.params.id, mode: 'create' })
        },
        {
          path: ":id/deviation-permit/:permitId",
          name: 'DeviationPermitEdit',
          component: DeviationPermitForm,
          props: (route) => ({
            moduleId: route.params.id,
            permitId: route.params.permitId,
            mode: 'edit'
          })
        },
        {
          path: ":id/risk-assessment/new",
          name: 'RiskAssessmentNew',
          component: RiskAssessmentForm,
          props: (route) => ({ moduleId: route.params.id, mode: 'create' })
        },
        {
          path: ":id/risk-assessment/:riskId",
          name: 'RiskAssessmentEdit',
          component: RiskAssessmentForm,
          props: (route) => ({
            moduleId: route.params.id,
            riskId: route.params.riskId,
            mode: 'edit'
          })
        },
        {
          path: ":id/nc-investigation/new",
          name: 'NcInvestigationNew',
          component: NcInvestigationForm,
          props: (route) => ({ moduleId: route.params.id, mode: 'create' })
        },
        {
          path: ":id/nc-investigation/:ncId",
          name: 'NcInvestigationEdit',
          component: NcInvestigationForm,
          props: (route) => ({
            moduleId: route.params.id,
            ncId: route.params.ncId,
            mode: 'edit'
          })
        },
        {
          path: ":id/product-correction/new",
          name: 'ProductCorrectionNew',
          component: ProductCorrectionForm,
          props: (route) => ({ moduleId: route.params.id, mode: 'create' })
        },
        {
          path: ":id/product-correction/:correctionId",
          name: 'ProductCorrectionEdit',
          component: ProductCorrectionForm,
          props: (route) => ({
            moduleId: route.params.id,
            correctionId: route.params.correctionId,
            mode: 'edit'
          })
        }
      ]
    },
    {
      path: '/countries',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'countries'},
      children: [
        {path: "/countries", name: 'Countries', component: Countries},
      ]
    },
    {
      path: '/contracts',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'contracts'},
      children: [
        {path: "/contracts", name: 'Contracts', component: Contracts},
      ]
    },
    {
      path: '/organizations',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'organizations'},
      children: [
        {path: "/organizations", name: 'Organizations', component: Organizations},
      ]
    },
    {
      path: '/vat-rates',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'vat_rates'},
      children: [
        {path: "/vat-rates", name: 'VatRates', component: VatRates},
      ]
    },
    {
      path: '/supplier-orders',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'supplier_orders'},
      children: [
        {path: "/supplier-orders", name: 'SupplierOrders', component: SupplierOrders},
      ]
    },
    {
      path: '/otk-reports',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'otk_reports'},
      children: [
        {path: "/otk-reports", name: 'OtkReports', component: OtkReportsIndex},
      ]
    },
    {
      path: '/roles',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'roles'},
      children: [
        {path: '', name: 'Roles', component: () => import('@/pages/roles/Index.vue')},
      ]
    },
    {
      path: '/data-collection',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {path: "/data-collection", name: 'DataCollection', component: DataCollectionIndex},
        {path: "/data-collection/list/:id", name: 'DataCollectionShow', component: DataCollectionShow, props: true},
        {path: "/data-collection/:id", name: 'DataCollectionModule', component: DataCollectionIndex, meta: {moduleParam: 'id'}},
      ]
    },
    {
      path: '/products',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'products'},
      children: [
        {path: "/products", name: 'Products', component: Products},
        {path: "/products/edit/:id", name: 'ProductEdit', component: ProductEditPage, props: true},
      ]
    },
    {
      path: '/product-units',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {path: "/product-units", name: 'ProductUnits', component: ProductUnitsIndex},
        {path: "/product-units/edit/:id", name: 'ProductUnitEdit', component: ProductUnitEdit, props: true},
      ]
    },
    {
      path: '/onecRequests',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {path: "/onecRequests", name: 'OneCRequests', component: OneCRequestsIndex},
      ]
    },
    {
      path: '/companies',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'companies'},
      children: [
        {path: "/companies", name: 'Companies', component: CompanyIndex},
      ]
    },
    {
      path: '/users',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'users'},
      children: [
        {path: "/users", name: 'Users', component: UserIndex},
      ]
    },
    {
      path: '/workshops',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'workshops'},
      children: [
        {path: "/workshops", name: 'Workshops', component: WorkshopIndex},
      ]
    },
    {
      path: '/workshopPosts',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'workshop_post_types'},
      children: [
        {path: "/workshopPosts", name: 'WorkshopPosts', component: WorkshopPostIndex},
      ]
    },
    {
      path: '/workshopPostUnits',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'workshop_posts'},
      children: [
        {path: "/workshopPostUnits", name: 'WorkshopPostUnits', component: WorkshopPostUnitIndex},
      ]
    },
    {
      path: '/modules',
      component: Authenticated,
      meta: {requiresAuth: true, section: 'modules'}, // Защищенный маршрут (требует авторизации)
      children: [
        {
          path: '', // Пустой путь означает, что это будет основной маршрут для /modules
          name: 'Modules',
          component: ModulesIndex,
        },
        {
          path: ':id', // Динамический параметр ID для страницы подробностей
          name: 'ModuleDetails',
          component: ModuleDetails,
          props: true, // Передаем параметр id как пропс в компонент
        },
      ],
    },
    {
      path: '/navigation-settings',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {path: '', name: 'NavigationSettings', component: NavigationSettingsPage},
      ],
    },
    {
      path: '/module-group/:groupId',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {
          path: '',
          name: 'ModuleGroup',
          component: ModuleGroupPage,
          props: (route) => ({id: route.params.groupId}),
        },
      ],
    },
    {
      path: '/orders',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {
          path: '/orders/:moduleId',
          meta: {moduleParam: 'moduleId'},
          name: 'Orders',
          component: OrdersIndex, // Страница со списком заказов
        },
        {
          path: '/orders/add',
          name: 'AddOrder',
          // id модуля в пути нет — доступ проверяем по типу модуля (см. meta.moduleType)
          meta: {moduleType: 'orders'},
          component: AddOrEditOrderPage, // Страница добавления заказа
          props: (route) => ({moduleId: route.query.moduleId}), // Передаем moduleId через query
        },
        {
          path: '/orders/edit/:id',
          name: 'EditOrder',
          meta: {moduleType: 'orders'}, // :id — заказ, не модуль
          component: AddOrEditOrderPage, // Страница редактирования заказа
          props: (route) => ({
            id: route.params.id,
            moduleId: route.query.moduleId, // Передаем moduleId через query
          }),
        },
      ],
    },
    {
      path: '/view-batch-manufacture',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {
          path: ':id',
          name: 'ViewBatchManufacture',
          component: ViewBatchManufacture,
          props: (route) => ({
            id: route.params.id,
            moduleId: route.query.moduleId,
            from: route.query.from,
            returnTab: route.query.returnTab
          }),
          meta: {title: 'Партия поставщика'}
        }
      ]
    },
    {
      path: '/batch-products',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {path: '/batch-products', name: 'BatchProducts', component: BatchProductsIndex},
      ]
    },
    {
      path: '/notifications',
      component: Authenticated,
      meta: {requiresAuth: true},
      children: [
        {path: '', name: 'Notifications', component: NotificationsIndex},
      ]
    },
    {
      path: '/production',
      component: Authenticated, // Обертка для аутентифицированных пользователей
      meta: {requiresAuth: true}, // Требуется авторизация
      children: [
        {
          path: ":id",
          meta: {moduleParam: 'id'},
          name: 'Production', // Имя маршрута
          component: ProductionIndex, // Компонент для страницы заказов
        },
        {
          path: "tech-map/:id",
          name: 'TechMapShow', // Имя маршрута
          meta: {moduleType: 'production'}, // :id — техкарта, не модуль
          component: TechMap, // Компонент для страницы заказов
        },
        {
          path: 'tech-map/edit/:id',
          name: 'TechMapEdit',
          // Страница редактирования: нужен полный доступ хотя бы к одному модулю производства
          meta: {moduleType: 'production', moduleTypeEdit: true},
          component: TechMapEdit,
        },
        {
          path: "orders/:id",
          name: "ProductionOrderShow",
          meta: {moduleType: 'production'}, // :id — заказ на производство, не модуль
          component: ProductionOrderShow,
          props: true
        },
      ],
    },
    {
      path: '/auth',
      redirect: "/login",
      component: Guest,
      meta: {isGuest: true},
      children: [
        // {path: "/register", name: 'Register', component: Register},
        {path: "/login", name: 'Login', component: Login},
        {path: "/verify-email", name: 'VerifyEmail', component: VerifyEmail},
        {path: "/two-factor-challenge", name: 'TwoFactorChallenge', component: TwoFactorChallenge},
        {path: "/forgot-password", name: 'ForgotPassword', component: ForgotPassword},
        {path: "/reset-password/:token", name: 'ResetPassword', component: ResetPassword},
      ]
    },
    {
      path: '/auth/user-select',
      component: Guest,
      children: [
        {path: "", name: 'UserSelect', component: UserSelect}
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: NotFound,
    }
  ],
});

/**
 * Тост об отказе в доступе. Тост живёт в layouts/App.vue и регистрируется
 * в utils/appToast.js при монтировании — из guard'а до компонента иначе не дотянуться.
 */
function showAccessDeniedToast() {
  appToastError('Нет доступа')
}

/**
 * Доступ к карточкам, открытым по id документа, а не по id модуля
 * (`/production/orders/:id`, `/orders/edit/:id` и т. п.): id модуля в пути нет,
 * поэтому маршрут объявляет тип модуля в `meta.moduleType` (ключ App\Models\ModuleType),
 * а доступ считается по модулям пользователя этого типа.
 *
 * @param {object} authStore стор авторизации
 * @param {string} moduleType ключ типа модуля (`production`, `orders`)
 * @param {boolean} needEdit требуется полный доступ (страница редактирования)
 * @returns {boolean} есть ли доступ хотя бы к одному модулю этого типа
 */
function hasAccessToModuleType(authStore, moduleType, needEdit = false) {
  const modules = authStore.user?.modules || []
  return modules.some((module) => module.key === moduleType
    && (needEdit ? authStore.canEditModule(module.id) : authStore.canModule(module.id)))
}

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // Если переходим по пути выбора пользователя, всегда пропускаем
  if (to.path === '/auth/user-select') {
    next();
    return;
  }

  if (to.meta.requiresAuth && !authStore.currentUser) {
    next({name: "Login"})
  } else if (to.meta.isGuest && authStore.currentUser) {
    next({name: "Home"})
  } else if (authStore.currentUser && to.meta.section && !authStore.canSection(to.meta.section)) {
    // Раздел администрирования закрыт ролью
    showAccessDeniedToast()
    next({name: "Home"})
  } else if (
    authStore.currentUser
    && to.meta.moduleParam
    && !authStore.canModule(to.params[to.meta.moduleParam])
  ) {
    // Страница модуля: id модуля лежит в параметре маршрута, названном в meta.moduleParam
    showAccessDeniedToast()
    next({name: "Home"})
  } else if (
    authStore.currentUser
    && to.meta.moduleType
    && !hasAccessToModuleType(authStore, to.meta.moduleType, to.meta.moduleTypeEdit === true)
  ) {
    // Карточка без id модуля в пути: доступ считаем по модулям пользователя нужного типа
    showAccessDeniedToast()
    next({name: "Home"})
  } else {
    next();
  }
});

export default router;
